<span>Users (search type - {{ searchInfo[searchColumn].label }})</span>
<nz-input-group nzCompact class="mt-5">
	<nz-select nzAllowClear nzShowSearch nzServerSearch nzPlaceHolder="Type to search user" 
		[nzLoading]="loading || searchLoading || scrollLoading"
		[nzDropdownRender]="renderTemplate"
		[(ngModel)]="selectedUser"
		(nzOnSearch)="search($event)"
		(nzScrollToBottom)="scrollToBottom()"
		(ngModelChange)="userChange()"
	>
		<ng-container *ngFor="let user of users">
			<nz-option nzCustomContent 
				[nzValue]="user"
				[nzLabel]="user?.fName + (user?.fUsername ? ' - ' + user?.fUsername : '')" 
				*ngIf="user?.fName"
			>
				<span [class.text-danger]="user?.fDeleted == 1">
					{{ user?.fName + (user?.fUsername ? ' - ' + user?.fUsername : '') }}
				</span>
			</nz-option>
		</ng-container>
		<nz-option *ngIf="loading || searchLoading" nzDisabled nzCustomContent>
			<span nz-icon nzType="loading"></span>
			Loading Data...
		</nz-option>
	</nz-select>
	<nz-select class="search-type" nzPlaceHolder="Search type"
		[(ngModel)]="searchColumn"
		(ngModelChange)="setSearchInfo()"
	>
		<ng-container *ngFor="let item of searchInfo | keyvalue: keeporder">
			<nz-option [nzValue]="item.key" [nzLabel]="item.value['label']"></nz-option>
		</ng-container>
	</nz-select>
</nz-input-group>
<ng-template #renderTemplate>
	<nz-spin *ngIf="scrollLoading"></nz-spin>
</ng-template>